import { PostSkill } from '../interfaces/api_skill.interfaces';

const DEFAULT_COLOR_SKILL: string = '#DDAA88';

export const MIN_RNCP_LEVEL_SKILL: number = 1;
export const MAX_RNCP_LEVEL_SKILL: number = 8;
export const REGEX_RNCP_CODE: RegExp = /^RNCP[0-9]{1,5}$/;

export const DEFAULT_POST_SKILL: PostSkill = { siteId: '', name: '', color: DEFAULT_COLOR_SKILL, rncpCode: undefined, rncpLevel: undefined,  users: [] };